'use client';

import { createSlice } from '@reduxjs/toolkit';
import { ProdutoType } from '../../types';

const initialState : ProdutoType = {
  id: 0,
  type: '',
  attributes: {
    id: 0, status: '', product_images: [], components: [], price: undefined
  },
  collections: []
};

export const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    changeState: (state, action) => {
      return {
        ...state, ...action.payload
      }
    }
  },
});

export const { changeState } = productSlice.actions;
export default productSlice.reducer;
